/**
 * Dashboard WorkWith is Parents, Donors, or Students.
 * Labels for the list ("All parents") and the details ID ("parentId: 12")
 * come from that setting — never a hardcoded parents default.
 */

export type WorkWithKind = 'donors' | 'parents' | 'students'

export function normalizeWorkWith(workWith: string | null | undefined): WorkWithKind {
    const w = (workWith || '').toString().trim().toLowerCase()
    if (w === 'donors' || w === 'donor') {
        return 'donors'
    }
    if (w === 'students' || w === 'student') {
        return 'students'
    }
    return 'parents'
}

export function workWithAllListLabel(workWith: string | null | undefined): string {
    switch (normalizeWorkWith(workWith)) {
        case 'donors':
            return 'All donors'
        case 'students':
            return 'All students'
        default:
            return 'All parents'
    }
}

export function workWithEntityIdLabel(workWith: string | null | undefined): string {
    switch (normalizeWorkWith(workWith)) {
        case 'donors':
            return 'donorId'
        case 'students':
            return 'studentId'
        default:
            return 'parentId'
    }
}

export function formatWorkWithEntityId(
    workWith: string | null | undefined,
    id: number | string,
): string {
    return `${workWithEntityIdLabel(workWith)}: ${id}`
}

export function workWithPersonNoun(workWith: string | null | undefined): string {
    switch (normalizeWorkWith(workWith)) {
        case 'donors':
            return 'donor'
        case 'students':
            return 'student'
        default:
            return 'parent'
    }
}
